import './App.css';


import MainBody from './components/MainBody';
import Header from './components/Header'
import Docs from './components/Docs';
import Mind from './components/Mind';
import Mindpart from './components/Mindpart'
import Comp_one from './components/Comp_one';
import Comp_two from './components/Comp_two';
import Comp_three from './components/Comp_three';
import Upcoming from './components/Upcoming';
import Footer from './components/Footer';


function App() {
  return (



    <div>


     <Header/>
      <MainBody/>
      <Docs/>
      <Mind/>
      <Mindpart/>
      <Comp_one/>


      <Comp_two/>
      <Comp_three/>

      <Upcoming/>
      <Footer/>

    

      




 


   </div>
  
  
    
  );
}

export default App;
